import { stepsStatuses } from 'constants/constants';

export const TABS = [
  {
    label: 'translation:dashboard_recruiter.tab_active_candidates',
    key: 'candidates',
  },
  {
    label: 'translation:dashboard_recruiter.tab_ssc',
    key: 'ssc',
  },
  {
    label: 'translation:dashboard_recruiter.tab_promotion_requests',
    key: 'promotion-requests',
  },
] as const;

export const CANDIDATES_GROUP = [
  { value: '', label: 'None', tableData: '' },
  { value: 'actions', label: 'Action', tableData: 'actions' },
  { value: 'jobs', label: 'Job', tableData: 'jobs' },
  { value: 'steps', label: 'Step', tableData: 'steps' },
];

export const INITIAL_VALUES = {
  sorting: { key: 'candidate', order: 'asc', field: 'candidate' },
  limit: { value: 30, label: 30 },
  page: 1,
  offset: 0,
  itemsCount: 0,
  only_with_actions: false,
};

export const BUTTON_LABELS: Record<string, string> = {
  [stepsStatuses.waitForResolution]: 'Submit Decision',
  [stepsStatuses.waitingForFinalDecision]: 'Submit Final Decision',
  [stepsStatuses.provideFeedback]: 'Provide feedback',
  [stepsStatuses.scheduleInterview]: 'Schedule interview',
  [stepsStatuses.sendOffer]: 'Add Offer',
  [stepsStatuses.receiveFeedback]: 'Submit Decision',
};
